export default __webpack_public_path__ + "static/media/formula.4ef5639d.svg";